const PRIMARY = {
  // lighter: '#FFE9B3',
  light: '#000000',
  main: '#000000',
  // dark: '#B38626',
  // darker: '#80631B',
  // contrastText: '#FFFFFF',
}

const palette = {
  primary: PRIMARY,
  common: {
    purple: 'rgba(231, 233, 254, 1)',
    green: 'rgba(230, 244, 241, 1)',
    red: 'rgba(255, 226, 227, 1)',
    yellow: 'rgba(241, 255, 201, 1)',
  },
}

export default palette
